import { useState, useEffect } from 'react';
import { getPhotosByCategory } from '../lib/api/adminApi';

const CheckIcon = () => (
  <svg viewBox="0 0 14 14" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="2 7 5.5 10.5 12 3.5" />
  </svg>
);

const AVANTAGES = [
  {
    title: 'Éligibilité à MaPrimeRénov\'',
    desc: 'Votre installation ouvre droit aux aides de l\'ANAH allant jusqu\'à 10 000 € selon vos revenus.',
  },
  {
    title: 'Certificats d\'Économies d\'Énergie (CEE)',
    desc: 'Cumulez les primes CEE des fournisseurs d\'énergie pour réduire encore davantage votre reste à charge.',
  },
  {
    title: 'TVA à taux réduit 5,5 %',
    desc: 'Les travaux de rénovation énergétique réalisés par un artisan RGE bénéficient du taux de TVA réduit.',
  },
  {
    title: 'Économies d\'énergie durables',
    desc: 'Une pompe à chaleur bien dimensionnée réduit votre consommation de chauffage jusqu\'à 75 % par rapport à une chaudière fioul.',
  },
];

const RGE = () => {
  const [rgePhoto, setRgePhoto] = useState(null);

  useEffect(() => {
    getPhotosByCategory('Illustration RGE')
      .then(({ data }) => { if (data.length > 0) setRgePhoto(data[0]); })
      .catch(() => {});
  }, []);

  return (
    <section className="section section-alt" id="rge">
      <div className="section-inner">
        <div className="rge-grid">
          <div className="rge-text-top">
            <div className="section-tag" style={{ display: 'inline-block', marginBottom: 16 }}>
              Certification RGE
            </div>

            <div className="rge-badge">
              <div className="rge-badge-icon">RGE</div>
              <div>
                <div className="rge-badge-label">Reconnu Garant de l'Environnement</div>
                <div className="rge-badge-desc">Qualification QualiPAC — Pompes à chaleur</div>
              </div>
            </div>

            <h2>Pourquoi choisir un artisan RGE ?</h2>
            <p>
              La certification RGE (Reconnu Garant de l'Environnement) est indispensable pour que
              vous puissiez bénéficier des aides financières de l'État sur vos travaux de rénovation
              énergétique. Tramenergie est qualifié QualiPAC pour l'installation de pompes à chaleur.
            </p>
          </div>

          <div className="rge-text-bottom">
            <ul className="rge-list">
              {AVANTAGES.map(({ title, desc }) => (
                <li key={title} className="rge-item">
                  <div className="rge-check">
                    <CheckIcon />
                  </div>
                  <div className="rge-item-text">
                    <strong>{title}</strong>
                    <span>{desc}</span>
                  </div>
                </li>
              ))}
            </ul>

            <div style={{ marginTop: 36 }}>
              <a href="#contact" className="btn btn-accent">Avoir un devis</a>
            </div>
          </div>

          <div className="rge-visual">
            {rgePhoto ? (
              <img
                src={rgePhoto.url}
                alt={rgePhoto.title ?? 'Pompe à chaleur RGE'}
                style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', borderRadius: 'inherit' }}
              />
            ) : (
              <div style={{
                background: 'linear-gradient(135deg, #052e16 0%, #14532d 30%, #15803d 60%, #0ea5e9 100%)',
                position: 'absolute', inset: 0,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                <div style={{
                  textAlign: 'center', padding: '0 32px',
                  color: 'rgba(255,255,255,0.2)', fontSize: '0.8rem',
                  fontWeight: 600, textTransform: 'uppercase', letterSpacing: '2px',
                }}>
                  Photo pompe à chaleur à venir
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default RGE;
